/* START_MODULE_CONTRACT
 * PURPOSE: API wrapper для GET /api/features.
 * SCOPE: fetchFeatureFlags.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, M-FE-FEATURE-TOGGLE, V-M-FE-API
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * fetchFeatureFlags - GET /api/features
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-08-10 - UC-022 featureToggleApi.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_fetchFeatureFlags */
/* START_CONTRACT: fetchFeatureFlags
 * PURPOSE: Загрузить итоговые feature flags с бэкенда.
 * INPUTS: { signal?: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse<{ enableRegistration: boolean }>> }
 * SIDE_EFFECTS: HTTP GET /api/features
 * LINKS: M-FEATURE-TOGGLE-API
 * END_CONTRACT: fetchFeatureFlags
 */
export function fetchFeatureFlags(signal) {
  return apiClient.get('/api/features', { signal });
}
/* END_METHOD_fetchFeatureFlags */
